export default "__VITE_PUBLIC_ASSET__61c9fb19__"